import React from 'react';
import Icon from '../../../components/AppIcon';
import { useTranslation } from 'react-i18next';

const StatCard = ({ title, value, change, changeType, icon, iconColor, onClick }) => {
  const { t } = useTranslation();
  const isPositive = changeType === 'positive';
  const changeIcon = isPositive ? 'TrendingUp' : 'TrendingDown';
  const changeColor = isPositive ? 'text-success' : 'text-error';

  return (
    <div 
      onClick={onClick}
      className={`bg-card rounded-xl p-4 md:p-6 border border-border shadow-elevation-1 transition-all duration-250 
        ${onClick ? 'cursor-pointer hover:shadow-elevation-2 hover:border-primary/40 hover:-translate-y-1' : ''}`}
    >
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <p className="text-[10px] md:text-xs font-black uppercase tracking-widest text-muted-foreground mb-1">
            {t(title)} 
          </p>
          <h3 className="text-xl md:text-2xl lg:text-3xl font-black text-foreground">
            {value}
          </h3>
        </div>
        <div 
          className="flex items-center justify-center w-10 h-10 md:w-12 md:h-12 rounded-lg shrink-0"
          style={{ backgroundColor: `${iconColor}15` }}
        >
          <Icon name={icon} size={20} color={iconColor} />
        </div>
      </div>
      
      {change && (
        <div className="flex items-center gap-1">
          <Icon name={changeIcon} size={14} color="currentColor" className={changeColor} />
          <span className={`text-xs md:text-sm font-bold ${changeColor}`}>
            {change}
          </span>
          <span className="text-[10px] font-medium text-muted-foreground ml-1">
            {t('home_dipendente.stats.vs_last_month')}
          </span>
        </div>
      )}
    </div>
  );
};

export default StatCard;